export interface IBoletaConfiguracionExtra2 {
    usaMateriaMaestro: boolean
    cabeceras_extras: string[]
    rel_1: [string, string, (number[] | null | undefined)][]
}

export interface IBoletaEscuelaConfiguracion {
    Extras: null | IBoletaConfiguracionExtra2
    Id: number
    IdPlantilla: number
    IdsGrado: number[]
    IdsNivel: number[]
    Modificacion: null
    Nombre: string
}

export interface IBoletaPlantilla {
    EnUso: boolean
    Extras: IBoletaConfiguracionExtra2 | null
    Id: number
    IdPlantilla: number
    IdsGrado: number[] | null
    IdsNivel: number[] | null
    Modificacion: string
    Nombre: string
}

export enum CBoletaPlantillaBase {
    Plantilla1 = 1,
    Plantilla2 = 2,
}

export interface IBoletaConfiguracion {
    Id: number,
    IdPlantilla: number,
    Extras: IBoletaConfiguracionExtra2 | null,
}